import { useCallback, useRef } from 'react';
import { HomeHero } from 'scripts/animations/three/home-hero';
import { runEvent } from 'scripts/animations/three/utils/run';
import { PrimaryIconMaterial, SecondaryIconMaterial } from './common/materials';
import { GLTFData } from 'scripts/animations/three/types/gltf';
import { useGLTF } from '@react-three/drei';

import ModelUrl from 'assets/gl/home/hero/hearts.glb?url';
import { HoverWrapper } from 'scripts/animations/three/helpers/hoverWrap';

type HeartProps = JSX.IntrinsicElements['group'] & {
    // nothing here yet!
};

type HeartsGLTF = GLTFData<'heart005'>;

export const Hearts = (props: HeartProps) => {

    const { nodes: { heart005: heart } } = useGLTF(ModelUrl) as HeartsGLTF;

    const rootRef = useRef<THREE.Group>();

    const onHover = useCallback(() => {
        runEvent(HomeHero.Events.Hover.Hearts, { root: rootRef.current });
    }, []);

    const onHoverOut = useCallback(() => {
        runEvent(HomeHero.Events.Hover.HeartsOut, { root: rootRef.current });
    }, []);

    return (
        <group
            ref={rootRef}
            name="heart" position={[474.13, 300.53, 0]}
            {...props}
        >
            <group name="heart_float">
                <group
                    name="heart1"
                    position={[0, -0.01, 0]}
                    rotation={[0, -0.25, 0]}
                >
                    <HoverWrapper
                        name="hearts_hover"
                        onPointerEnter={onHover}
                        onPointerOut={onHoverOut}
                        scale={1.5}
                    />
                    <group name="heart 3" position={[0, 0.01, 0]} scale={0}>
                        <mesh
                            name="heart2"
                            geometry={heart.geometry}
                            material={SecondaryIconMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 0.04, 0]}
                            rotation={[-0.21, -0.69, -0.13]}
                            scale={2}
                        />
                    </group>
                    <group name="heart 2" position={[0, 0.01, 0]} scale={0}>
                        <mesh
                            name="heart3"
                            geometry={heart.geometry}
                            material={SecondaryIconMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 0.04, 0]}
                            rotation={[-0.21, -0.69, -0.13]}
                            scale={2}
                        />
                    </group>
                    <group name="heart4" position={[0, 0.01, 0]}>
                        <mesh
                            name="heart5"
                            geometry={heart.geometry}
                            material={PrimaryIconMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 0.04, 0]}
                            rotation={[-0.21, -0.69, -0.13]}
                            scale={2}
                        />
                    </group>
                </group>
            </group>
        </group>
    );
};

export const preloader = () => useGLTF.preload(ModelUrl);
